import { render, staticRenderFns } from "./GainOnSale2.vue?vue&type=template&id=1c91fa77&"
import script from "./GainOnSale2.vue?vue&type=script&lang=js&"
export * from "./GainOnSale2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports